import { render, staticRenderFns } from "./prdList.vue?vue&type=template&id=9a6cf3ce&scoped=true"
import script from "./prdList.vue?vue&type=script&lang=js"
export * from "./prdList.vue?vue&type=script&lang=js"
import style0 from "./prdList.vue?vue&type=style&index=0&id=9a6cf3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6cf3ce",
  null
  
)

export default component.exports